import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { FiX, FiAlertCircle } from "react-icons/fi";
import { COLOR_GRAY_TEXT } from "../../../../../../constants/Colors";
import LogButton from "../../../../../../components/atoms/LogButton";
import axios from "axios";
import {
  errorToast,
  successToast,
} from "../../../../../../services/toastService";
import { postInvoiceCleanUp } from "../../../../../../api/modules";

const ModalLogStyled = styled(Modal)`
  opacity: 1;
  .modal-content {
    border-radius: 15px !important;
    padding: 20px;
  }
  p {
    color: ${COLOR_GRAY_TEXT};
  }
`;

const prettierType = {
  invoice: "Factura",
  invoiceDadorComision: "Factura Comisión",
  invoiceTomadorComision: "Factura Comisión Tomador",
  liquidProduct: "Líquido Producto",
  creditNote: "Nota de credito",
};

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #000;
  &:hover {
    color: #ff0000;
  }
`;

const IconError = styled(FiAlertCircle)`
  font-size: 50px;
  color: red;
`;

const JsonContainer = styled.pre`
  background: #f3f3f3;
  padding: 15px;
  border-radius: 10px;
  max-height: 300px;
  overflow-y: auto;
  font-size: 13px;
  color: #333;
`;

const ModalError = ({ isShow, handleClose, type, data, refetch }) => {
  if (!data) return null;

  const facturanteResp = data?.facturante_response || null;

  const handleCleanup = async () => {
    if (!data._id) return;
    const { msg } = await postInvoiceCleanUp({
      _id: data._id,
      type,
    });

    if (msg) {
      errorToast(msg || "Intente Nuevamente");
    } else {
      successToast(
        `${prettierType[type] || "Comprobante"} desafectado, ahora puede intentar nuevamente`
      );
      refetch();
      handleClose();
    }
  };

  return (
    <ModalLogStyled show={isShow} onHide={handleClose} centered size="lg">
      <Modal.Header>
        <CloseButton onClick={handleClose}>
          <FiX />
        </CloseButton>
      </Modal.Header>

      <Modal.Body className="pt-0">
        <Row className="text-center">
          <Col>
            <IconError />
            <h4>Error en {prettierType[type] || "N/D"}</h4>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col>
            <JsonContainer>
              {JSON.stringify(facturanteResp, null, 2)}
            </JsonContainer>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer className="footer-modal">
        <Col className="d-flex justify-content-between p-0 m-0">
          <LogButton
            color="danger"
            border="curve"
            title="Limpiar error"
            className="w-45"
            onClick={handleCleanup}
            disabled={!data._id}
          />

          <LogButton
            className="w-45"
            color="primary"
            onClick={handleClose}
            title="Cerrar"
            border="curve"
          />
        </Col>
      </Modal.Footer>
    </ModalLogStyled>
  );
};

export default ModalError;
